export function isRGBA (colorStr: string) {
  return /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/.test(colorStr);
}
